export const YOUTUBE_API_KEY = 'AIzaSyCrrucRr4U7xjtlq9rUPe7ruHVr_G3BiEk';
export const YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3/search';
// const HtmlWebpackPlugin = require('html-webpack-plugin');
// const webpack = require('webpack'); //to access built-in plugins

// module.exports = {
//   module: {
//     rules: [{ test: /\.txt$/, use: 'raw-loader' }],
//   },
//   plugins: [new HtmlWebpackPlugin({ template: './../components/indexdesktopsearch.html' })],
// };
module.exports = {
    // …
    module: {
      rules: [
        {
          test: /\.m?js$/,
          include: [
            /node_modules[\\/]@sentry[\\/]browser/,
            /node_modules[\\/]@sentry[\\/]core/
          ],
          use: {
            loader: 'babel-loader',
            options: {
              // make sure optional chaining is handled
              presets: ['@babel/preset-env'],
              plugins: ['@babel/plugin-proposal-optional-chaining']
            }
          }
        },
        // your existing JS rules…
      ]
    }
  };
  